const request = require('superagent');

const StoreAPI = {
    getStores: () => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/multi_stores`)
        .set('Accept', 'application/json')
        .send(),

    getGroupedStores: () => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/grouped_stores`)
        .set('Accept', 'application/json')
        .send(),
    getStoreById: (storeId) => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/multi_stores/${storeId}`)
        .set('Accept', 'application/json')
        .send(),

    getStorePayments: (storeId) => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v1/multi_stores/${storeId}/payment`)
        .set('Accept', 'application/json')
        .send(),

    getStoresByZone: (zoneId, page, limit) => request
        .get(`${process.env.REACT_APP_MAIN_STORE_API_HOST}/api/v2/storefront/stores`)
        .query({ zoneId, page, limit })
        .set('Accept', 'application/json')
        .send(),
};

export default StoreAPI;



/** WEBPACK FOOTER **
 ** ./src/apis/store.js
 **/